<div class="container-fluid">
        <div id="overlay" *ngIf="iSLoading">
                <div id="loading-center">
                    <div id="loading-center-absolute">
                        <div class="object" id="object_four"></div>
                        <div class="object" id="object_three"></div>
                        <div class="object" id="object_two"></div>
                        <div class="object" id="object_one"></div>
                    </div>
                </div>
            </div>
    <!-- <ng4-loading-spinner [loadingText]="'Please wait...'" ></ng4-loading-spinner> -->
    <alert></alert>
    <router-outlet></router-outlet>
</div>